import { render, staticRenderFns } from "./ProfilingTableParameters.vue?vue&type=template&id=cbba746a&scoped=true&lang=pug"
import script from "./ProfilingTableParameters.vue?vue&type=script&lang=js"
export * from "./ProfilingTableParameters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbba746a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cbba746a')) {
      api.createRecord('cbba746a', component.options)
    } else {
      api.reload('cbba746a', component.options)
    }
    module.hot.accept("./ProfilingTableParameters.vue?vue&type=template&id=cbba746a&scoped=true&lang=pug", function () {
      api.rerender('cbba746a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/profiling/ProfilingTableParameters.vue"
export default component.exports